import { gql } from '@/core/shared/api';
import { fullExperience } from './fragments';

export const getLocationExperiences = async ({ dispatch, commit, rootGetters }, locationId) => {
  commit('setLoading', true);
  commit('experiences/set', {
    path: 'isFetchingExperiences',
    value: true,
  });

  const query = `{
    experiences (locationId: "${locationId}") {
      ${fullExperience}
    }
  }`;

  try {
    const { experiences } = await gql.request(query);

    dispatch('insertEntities', {
      name: 'Experience',
      payload: experiences,
    });

    const experienceIdsFromApi = experiences.map(experience => experience.id);
    rootGetters['entities/Experience/all']().forEach(experience => {
      if (!experienceIdsFromApi.includes(experience.id)) {
        dispatch('removeEntities', {
          name: 'Experience',
          payload: experience,
        });
      }
    });

    return experiences;
  } finally {
    commit('setLoading', false);
    commit('experiences/set', {
      path: 'isFetchingExperiences',
      value: false,
    });
  }
};

export const getExperience = async ({ commit, dispatch }, experienceId) => {
  commit('setLoading', true);
  commit('experiences/set', {
    path: 'isFetchingExperiences',
    value: true,
  });

  const query = `{
    experience (experienceId: "${experienceId}") {
      ${fullExperience}
    }
  }`;

  try {
    const { experience } = await gql.request(query);

    dispatch('insertEntities', {
      name: 'Experience',
      payload: experience,
    });

    return experience;
  } finally {
    commit('setLoading', false);
    commit('experiences/set', {
      path: 'isFetchingExperiences',
      value: false,
    });
  }
};
